export const CAMPAIGN_APPROVAL_STATUS = Object.freeze({
  WAITING_APPROVAL: 'WAITING_APPROVAL',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  REJECTED: 'REJECTED',
  IN_PROGRESS: 'IN_PROGRESS',
})

export const CAMPAIGN_APPROVAL_STEP_TYPE = Object.freeze({
  LLM_DECISION: 'LLM_DECISION',
  HUMAN_GATE: 'HUMAN_GATE',
  EMAIL_SEND: 'EMAIL_SEND',
  ACTION: 'ACTION',
})

export const CAMPAIGN_TRIGGER_TYPE = Object.freeze({
  ROW_CREATED: 'ROW_CREATED',
  ROW_UPDATED: 'ROW_UPDATED',
  MANUAL_RUN: 'MANUAL_RUN',
})
